import React from "react";
import { Typography } from "@mui/material";
import { sideBarContent } from "./sidebarData";
import { Link } from "react-router-dom";
const SideBar = () => {
  return (
    <>
      <div className="side_bar__container">
        <Typography
          sx={{
            fontSize: 16,
            lineHeight: "20px",
            fontWeight: 700,
            textTransform: "capitalize",
            fontFamily: "'Archivo', sans-serif",
          }}
          className="archivo fw-bold"
        >
          ON A SIMILAR NOTE...
        </Typography>
        <div className="mt-3">
          {sideBarContent &&
            sideBarContent.map((item) => (
              <div
                key={item.id}
                className="d-flex gap-4 align-items-start mt-3"
              >
                <img
                  src={item.image}
                  alt={item.data}
                  style={{
                    width: 76,
                    height: 76,
                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                />
                <Link
                  to={item.link}
                  underline="hover"
                  style={{
                    fontSize: "13px",
                    lineHeight: "20px",
                    fontWeight: 400,
                    cursor: "pointer",
                  }}
                  className="archivo"
                >
                  {item.data}
                </Link>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default SideBar;
